import Marquee from "react-fast-marquee";
import shareTransferImg from "../../assets/images/share-transfer.png";
import { fpRealaatedArticales } from "../../data/relatedArticale";
import Faq from "../Faq";
import Meta from "../Meta";

export default function ShareTransfer() {
  const faqItems = [
    {
        title: 'What is share transfer in a company?',
        content: <strong>Share transfer is the process of transferring ownership of shares from one person (or entity) to another, usually with proper documentation and compliance with company law.</strong>
    },
    {
        title: 'Is stamp duty required on share transfer?',
        content: <strong>Yes, in most jurisdictions including Bangladesh, a stamp duty is applicable on the value of shares transferred. It must be paid to make the transaction legally valid.</strong>
    },
    {
        title: 'Can a private company freely transfer its shares?',
        content: <strong>Private companies typically have restrictions in their Articles of Association to control who can become a shareholder, so share transfer is subject to approval by the board.</strong>
    }
];

return (
    <>
        <Meta
            title="RJSC Share Transfer Services in Bangladesh | Share Transfer Agreement"
            description="Our business and corporate lawyers can help with drafting share transfer agreements for limited company share transfer. We assist in company share transfer for private and public companies in compliance with regulations."
            image={shareTransferImg}
            keywords="rjsc share transfer,share transfer agreement, ownership transfer, drafting share transfer agreements, limited company shares transfer, legal share transfer, private company shares transfer"
        />

        <div className="container-fluid hero-header bg-light py-5 mb-5">
            <div className="container py-5">
                <div className="row g-5 align-items-center">
                    <div className="col-lg-6">
                        <h1 className="display-4 mb-3 animated slideInDown">Share Transfer</h1>
                     <p>Share transfer agreement in Bangladesh involve the legal process of transferring ownership of shares in a company from one party to another. Our business and corporate lawyers can help with for limited company share transfer.</p>
                    </div>
                    <div className="col-lg-6 animated fadeIn">
                        <img className="img-fluid animated pulse infinite" style={{ animationDuration: '3s' }} src={shareTransferImg} alt='share-transfer-services' />
                    </div>
                </div>
            </div>
        </div>

        <div className="container-xxl py-5">
            <div className="container">
                <p className="color-text fs-5 mb-4"><b>What is Share Transfer?</b></p>
                <p>
                    Share transfer refers to the process by which a shareholder voluntarily gives up their ownership in a company to another person or entity. This transaction is governed by the company’s Articles of Association and must comply with legal requirements under the Companies Act of Bangladesh.
                    <br /><br />
                    Share transfers commonly occur due to changes in business structure, new investments, partnership exits, or internal restructuring. It is vital to maintain accurate records and follow the legal formalities to avoid disputes or regulatory issues.
                </p>

                <p className="color-text fs-5 mb-4"><b>Why is Share Transfer Important?</b></p>
                <p>
                    Transferring shares helps businesses grow, onboard new partners, or restructure ownership without dissolving the company. A properly conducted share transfer ensures transparency, legal compliance, and protection for both buyer and seller. It also protects the interests of the company by allowing management to retain control over new shareholders through internal approval.
                </p>
            </div>
        </div>

        <div className="container-xxl py-5">
            <div className="container">
                <div className="row g-5 align-items-center">
                  
                    <div className="col-lg-6">
                        <div className="h-100">
                            <p className="color-text fs-5 mb-4">
                                What services does ‘JK Associates’ provide regarding Share Transfer?
                            </p>
                            <p>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>Document Preparation: </b>We prepare the Share Transfer Deed, Board Resolutions, and all other necessary legal documents.</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>Regulatory Compliance: </b>We ensure the process complies with the Companies Act and Registrar of Joint Stock Companies (RJSC) regulations.</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>Board Resolution Drafting: </b>We help draft board resolutions and prepare necessary meeting minutes.</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>RJSC Filing: </b>We submit the required forms and documents to RJSC for approval and record updates.</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>Legal Advisory: </b>Our team offers guidance on restrictions, taxation, and ownership structuring based on your goals.</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>End-to-End Support: </b>From consultation to completion, we handle the process smoothly on your behalf.</span>
                                </div>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="container-xxl py-0">
            <div className="container">
                <p className="color-text fs-5 mb-4"><b>The Process of Share Transfer</b></p>
                <p>
                    The process typically includes:
                    <br /><br />
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span><b>Shareholder Agreement Review: </b>Check company constitution and shareholder agreement for any restrictions or conditions.</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span><b>Prepare Transfer Deed: </b>Draft and sign Form 117 along with stamp duty payment.</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span><b>Board Resolution: </b>Conduct a board meeting to approve the share transfer.</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span><b>Update Share Register: </b>The company updates its register of members.</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span><b>Filing with RJSC: </b>Submit relevant forms to RJSC for official record.</span>
                    </div>
                </p>

                <p className="color-text fs-5 mb-4"><b>Documents Required for Share Transfer</b></p>
                <p>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Signed Share Transfer Form (Form 117)</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Copy of Board Resolution</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Identification documents of transferor and transferee</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Updated Memorandum (if required)</span>
                    </div>
                </p>

                <p className="color-text fs-5 mb-4"><b>Things to Consider Before Transferring Shares</b></p>
                <p>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Check for any restrictions in the Articles of Association</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Ensure board approval and legal compliance</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Calculate applicable stamp duty</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Document the change with RJSC</span>
                    </div>
                </p>
            </div>
        </div>
            <p>
                    The share transfer services in Bangladesh involve the legal process of transferring ownership of shares in a company from one party to another. This process is governed by the Companies Act, 1994, and involves several key steps, including notifying the company, obtaining board approval, executing the transfer form (Form 117), and registering the transfer with the Registrar of Joint Stock Companies and Firms (RJSC).
                    <br /><br />
                    Our business and corporate lawyers can help with drafting share transfer agreements, conducting due diligence, and advising on legal and regulatory requirements. They can also assist with the transfer of shares by ensuring that all necessary paperwork is completed and filed with the relevant authorities.
                </p>

        <div className='container-xxl center-background1'>
            <h2> Related Articles</h2>
        </div>

        <div className='container-xxl center-background1'>
                 <Marquee className="marquee-container">
                   {
                    fpRealaatedArticales
                   }
                </Marquee>
        </div>

        <div className="container py-5 my-0">
            <h2 className="color-text text-center mb-4">Share Transfer FAQ</h2>
            <Faq items={faqItems} />
        </div>
    </>
)

}
